export const environment = {
  production: true,
  hmr: false,
  canonicalDomain: 'https://coda-apeldoorn.nl',
  advertiserId: '314', // custom pixel id for analytics
};
